function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { renderFromComponentMap, useDataAttributes } from '@goodrx/x-core';
import { Card, PressImage, Primary, Secondary } from './components';
import { trackLink } from '@goodrx/x-core';
import { DESKTOP_BREAKPOINTS, useBreakpoint } from '../../utils/react/useBreakpoint';
export const Link = props => {
  const {
    className,
    displayTitle,
    sys: {
      id
    },
    title,
    type,
    url
  } = props;
  const breakpoint = useBreakpoint();
  const attributes = useDataAttributes({
    content: displayTitle || '',
    contentId: id,
    contentTitle: title || '',
    screenSize: DESKTOP_BREAKPOINTS.includes(breakpoint) ? 'desktop' : 'mobile',
    type: type || 'default',
    url: url || ''
  });
  const linkRef = useRef(null);
  useEffect(() => {
    if (!linkRef.current) {
      return;
    }

    trackLink(linkRef.current, `${displayTitle} CTA Clicked`, attributes);
  }, [attributes, displayTitle]);
  const componentMap = {
    primary_button: () => /*#__PURE__*/React.createElement(Primary, _extends({}, props, {
      ref: linkRef,
      attributes: attributes,
      className: cn(className, 'linkType')
    })),
    secondary_button: () => /*#__PURE__*/React.createElement(Secondary, _extends({}, props, {
      ref: linkRef,
      attributes: attributes,
      className: cn(className, 'linkType')
    })),
    hd_card: () => /*#__PURE__*/React.createElement(Card, _extends({}, props, {
      ref: linkRef,
      attributes: attributes,
      className: cn(className, 'linkType')
    })),
    hd_press_image: () => /*#__PURE__*/React.createElement(PressImage, _extends({}, props, {
      ref: linkRef,
      attributes: attributes,
      className: cn(className, 'linkType')
    }))
  };
  return renderFromComponentMap(componentMap, type || 'primary_button');
};